<template>
  <div class="invoice-record">
    <div class="query-filter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_sqsj') }}</div>
              <div class="value">
                <custom-date-picker v-model="formSearch.gmtCreate" type="daterange" align="right" @change="onGmtCreateChange" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_kai_piao_zu_zhi') }}</div>
              <div class="value">
                <el-input v-model="formSearch.sellerOrgName" @input="onSellerOrgNameChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_kai_piao_ri_qi') }}</div>
              <div class="value">
                <custom-date-picker v-model="formSearch.invoiceTime" type="daterange" align="right" @change="onInvoiceTimeChange" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_fa_piao_hao_ma') }}</div>
              <div class="value">
                <el-input v-model="formSearch.invoiceNum" @input="onBuyerNumberChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_fa_piao_tai_tou') }}</div>
              <div class="value">
                <el-input v-model="formSearch.buyerName" @input="onBuyerNameChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('invoice_record_fa_piao_lei_xing') }}</div>
              <div class="value">
                <invoice-type-select
                  v-model="formSearch.invoiceTypeValue"
                  ref="invoiceTypeSelect"
                  @change="onInvoiceTypeValueChange"
                  :clearable="true"
                  :defaultValue="false"
                  :placeholder="$t('com_please_select')"
                ></invoice-type-select>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('invoice_record_shai_xuan_xiang') }}：</div>
        <div class="values">
          <el-tag closable v-for="dateTag in gmtCreateTagList" :key="dateTag.value" @close="onCloseGmtCreate(dateTag.value)">{{ dateTag.label }}</el-tag>
          <el-tag closable v-for="nameTag in sellerOrgNameTagList" :key="nameTag.value" @close="onCloseSellerOrgName(nameTag.value)">{{ nameTag.label }}</el-tag>
          <el-tag closable v-for="dateTag in invoiceTimeTagList" :key="dateTag.value" @close="onCloseInvoiceTime(dateTag.value)">{{ dateTag.label }}</el-tag>
          <el-tag closable v-for="nameTag in invoiceNumTagList" :key="nameTag.value" @close="onCloseBuyerNumber(nameTag.value)">{{ nameTag.label }}</el-tag>
          <el-tag closable v-for="nameTag in buyerNameTagList" :key="nameTag.value" @close="onCloseBuyerName(nameTag.value)">{{ nameTag.label }}</el-tag>
          <el-tag closable v-for="nameTag in invoiceTypeValueTagList" :key="nameTag.value" @close="onCloseInvoiceTypeValue(nameTag.value)">{{ nameTag.label }}</el-tag>
          <el-button type="info" size="mini" @click="onClear">{{ $t('com_clear') }}</el-button>
        </div>
      </div>
      <div class="table-bd">
        <custom-table
          tableCode="portal_invoice_record"
          height="500px"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['invoiceNum', 'invoiceAmount', 'invoiceType']"
        >
          <template v-slot:invoiceType="scope">
            {{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}
          </template>
          <template v-slot:invoiceAmount="scope">
            {{ formatInvoiceAmount(scope.row) }}
          </template>
          <template slot="invoiceNum" slot-scope="scope">
            <template v-if="scope.row.isRedInvoice">
              <span :class="scope.row.invoiceNum ? 'cell-link' : ''" @click="onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
              <span v-if="scope.row.oldInvoiceNum">/</span>
              <span v-if="scope.row.oldInvoiceNum" class="cell-link" @click="onInvoiceDetails(scope.row.oldInvoiceId)">{{ scope.row.oldInvoiceNum }}</span>
            </template>
            <template v-else>
              <span :class="scope.row.invoiceNum ? 'cell-link' : ''" @click="onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
            </template>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
    <!-- 发票详情 -->
    <invoice-details-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></invoice-details-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import invoiceTypeMixins from '@/utils/invoice_type_mixins.js';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';
import invoiceDetailsDialog from './children/invoice_details_dialog.vue';

// i18n-lang-component
// invoice_record_sqsj: 申请时间// invoice_record_kai_piao_zu_zhi: 开票组织// invoice_record_kai_piao_ri_qi: 开票日期// invoice_record_fa_piao_hao_ma: 发票号码// invoice_record_fa_piao_tai_tou: 发票抬头// invoice_record_fa_piao_lei_xing: 发票类型// invoice_record_shai_xuan_xiang: 筛选项// invoice_record_fpxq: 发票详情

export default {
  name: '',
  mixins: [invoiceTypeMixins],
  components: { invoiceDetailsDialog, invoiceTypeSelect },
  props: {},
  data() {
    return {
      formSearch: {
        pageSize: 50,
        pageNum: 1,

        // 申请时间
        gmtCreate: [],
        // 开票组织
        sellerOrgName: '',
        // 开票日期
        invoiceTime: [],
        // 发票号码
        invoiceNum: '',
        // 发票抬头
        buyerName: '',
        invoiceType: '',
        invoiceClass: '',
        invoiceTypeValue: '',
      },

      gmtCreateTagList: [],
      sellerOrgNameTagList: [],
      invoiceTimeTagList: [],
      invoiceNumTagList: [],
      buyerNameTagList: [],
      invoiceTypeValueTagList: [],

      tableList: [],
      totalRows: null,
      dialogModel: {},
      dialogVisible: false,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 格式化发票金额
    // 如果是红票，则发票金额为负数
    formatInvoiceAmount(row) {
      if (row.isRedInvoice) {
        if (row.invoiceAmount) {
          return -1 * row.invoiceAmount;
        }
      }
      return row.invoiceAmount;
    },
    onGmtCreateChange() {
      const data = this.formSearch.gmtCreate;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.gmtCreateTagList = [
          {
            label: `${start} - ${end}`,
            value: 'date',
          },
        ];
      } else {
        this.gmtCreateTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseGmtCreate() {
      this.formSearch.gmtCreate = [];
      this.onGmtCreateChange();
    },
    onSellerOrgNameChange() {
      const sellerOrgName = this.formSearch.sellerOrgName.trim();
      if (sellerOrgName) {
        this.sellerOrgNameTagList = [
          {
            label: sellerOrgName,
            value: 'sellerOrgName',
          },
        ];
      } else {
        this.sellerOrgNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseSellerOrgName() {
      this.formSearch.sellerOrgName = '';
      this.onSellerOrgNameChange();
    },
    onInvoiceTimeChange() {
      const data = this.formSearch.invoiceTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.invoiceTimeTagList = [
          {
            label: `${start} - ${end}`,
            value: 'date1',
          },
        ];
      } else {
        this.invoiceTimeTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseInvoiceTime() {
      this.formSearch.invoiceTime = [];
      this.onInvoiceTimeChange();
    },
    onBuyerNumberChange() {
      const invoiceNum = this.formSearch.invoiceNum.trim();
      if (invoiceNum) {
        this.invoiceNumTagList = [
          {
            label: invoiceNum,
            value: 'invoiceNum',
          },
        ];
      } else {
        this.invoiceNumTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onBuyerNameChange() {
      const buyerName = this.formSearch.buyerName.trim();
      if (buyerName) {
        this.buyerNameTagList = [
          {
            label: buyerName,
            value: 'buyerName',
          },
        ];
      } else {
        this.buyerNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseBuyerNumber() {
      this.formSearch.invoiceNum = '';
      this.onBuyerNumberChange();
    },
    onCloseBuyerName() {
      this.formSearch.buyerName = '';
      this.onBuyerNameChange();
    },
    onInvoiceTypeValueChange() {
      const invoiceTypeValue = this.formSearch.invoiceTypeValue;
      this.updateTypeAndClassByValue(this.formSearch, invoiceTypeValue);
      if (invoiceTypeValue) {
        const item = this.invoiceTypeData.find(obj => obj.value === invoiceTypeValue);
        this.invoiceTypeValueTagList = [
          {
            label: item.name,
            value: 'invoiceTypeValue',
          },
        ];
      } else {
        this.invoiceTypeValueTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseInvoiceTypeValue() {
      this.formSearch.invoiceTypeValue = '';
      this.onInvoiceTypeValueChange();
    },
    onClear() {
      this.formSearch.gmtCreate = '';
      this.formSearch.sellerOrgName = '';
      this.formSearch.invoiceTime = '';
      this.formSearch.invoiceNum = '';
      this.formSearch.buyerName = '';
      this.formSearch.invoiceTypeValue = '';
      this.formSearch.invoiceType = '';
      this.formSearch.invoiceClass = '';

      this.gmtCreateTagList = [];
      this.sellerOrgNameTagList = [];
      this.invoiceTimeTagList = [];
      this.invoiceNumTagList = [];
      this.buyerNameTagList = [];
      this.invoiceTypeValueTagList = [];

      this.onPageChange({ page: 1 });
    },
    onInvoiceDetails: function (invoiceId, isRedInvoice) {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      this.dialogModel.type = isRedInvoice;
      this.dialogModel.title = this.$t('invoice_record_fpxq');
      this.dialogModel.invoiceId = invoiceId;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      const reqData = this.formSearch;
      if (this.formSearch.gmtCreate && this.formSearch.gmtCreate.length) {
        const startDate = this.formSearch.gmtCreate[0];
        const endDate = this.formSearch.gmtCreate[1];
        reqData.gmtCreate = [startDate, endDate];
      } else {
        reqData.gmtCreate = [];
      }
      if (this.formSearch.invoiceTime && this.formSearch.invoiceTime.length) {
        const startDate = this.formSearch.invoiceTime[0];
        const endDate = this.formSearch.invoiceTime[1];
        reqData.invoiceTime = [startDate, endDate];
      } else {
        reqData.invoiceTime = [];
      }
      const url = apis.portalInvoicePage;
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
  },
  created() {},
  mounted() {
    this.mergeLanguage(null, 'portal_invoiceRecord');
    this.getCompLanguage(() => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss" scoped>
.invoice-record {
  padding: 24px;

  .table-bd {
    margin-top: 24px;
  }

  .custom-pagination {
    padding-bottom: 0 !important;
  }
}
</style>
